export enum MarginExpenseTypes {
    AIRFARE = 1,
    RENTAL_CAR = 2,
    HOUSING = 3,
    MILEAGE_REIMBURSEMENT = 4,
    LICENSE = 5,
    DEA = 6,
    REFERRAL_BONUS = 7,
    PATIENT_COMPENSATION_FUND = 8,
    EXPENSE_ALLOWANCE = 9,
    BAGGAGE_FEES = 10,
    OTHER = 11
}
